import { Button } from 'semantic-ui-react';
import styled, { css } from 'styled-components';

// Workaround until we move on from semantic ui
const StyledButton = styled(Button)<{
  $destructive: boolean;
  $disabled: boolean;
  $hasIcon: boolean;
}>`
  &&&&& {
    width: 100%;
    text-align: start;
    font-size: 14px;
    &:hover {
      background: ${({ theme }) => theme.colors.backgroundHover} !important;
    }

    ${({ $destructive, theme }) =>
      `color: ${
        $destructive ? 'var(--destructive)' : theme.colors.text
      } !important;`}

    ${({ $hasIcon }) =>
      $hasIcon
        ? css`
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 5px 13px;
            line-height: 24px;
          `
        : ``}

    ${({ $disabled }) =>
      $disabled
        ? css`
            opacity: 0.6;
            pointer-events: none;
          `
        : ``}
  }
`;

export const Styled = {
  Button: StyledButton,
};
